import { ReactNode } from 'react';
import { MarkdownRenderContext } from '@/ui';
import { renderers } from './renderers';

interface IMarkdownRenderContextProviderProps {
	children: ReactNode;
}

export function MarkdownRenderContextProvider({
	children,
}: IMarkdownRenderContextProviderProps) {
	return (
		<MarkdownRenderContext.Provider value={renderers}>
			{children}
		</MarkdownRenderContext.Provider>
	);
}
